import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { CommentFormAppManager } from 'apps/comments/main/appManager';
import { CommentConnManager } from 'apps/comments/main/connManager';
import { Center } from 'legacyComponents/styled/lib';
import { Spinner } from 'components';
import { Comment } from 'apps/comments/views/comment';
import styled from 'styled-components';
import { media } from 'legacyComponents/styled/styleUtils';
import { clientStore } from 'apps/client/app';
import { modalStore } from 'apps/modals/app';
import SignInModal from 'apps/signIn/main/modal';
import { AccessForm } from 'apps/profile/accessForm';
import { withNamespaces, Trans } from 'react-i18next';
import { HiddenComments } from 'apps/comments/views/hiddenComments';

@withNamespaces()
@observer
export class Comments extends React.Component {
  UNSAFE_componentWillMount() {
    this.commentsConnection = new CommentConnManager(null, this.props);
    this.appManager = new CommentFormAppManager(null, {
      props: this.props,
      commentsConnection: this.commentsConnection,
    });
  }

  clickSignIn = () => {
    modalStore.SetModalComponent(SignInModal);
  };

  clickRequestInvite = () => {
    modalStore.SetModalComponent(AccessForm);
  };

  render() {
    if (
      this.commentsConnection.loading &&
      this.commentsConnection.arrayApp.length === 0
    ) {
      return (
        <Wrapper>
          <Spinner margin='30px auto' />
        </Wrapper>
      );
    }
    const { contentType, thread, dataTestId, hideAction } = this.props;
    const comments = this.commentsConnection.arrayApp;
    const commentThread = comments.map(comment => (
      <Comment
        thread={thread}
        app={comment}
        key={comment.id}
        hideAction={hideAction}
      />
    ));
    const signedIn = clientStore.signedInProfile;

    return (
      <Wrapper data-testid={dataTestId}>
        {commentThread}
        {this.appManager.commentFormApp.form.posting ? (
          <Spinner margin='30px auto' />
        ) : (
          <React.Fragment />
        )}
        {signedIn === null ? (
          <Wrapper>
            <Center>
              <SignInUpMessge>
                <Trans>
                  {INVITE_MODE ? (
                    <span onClick={this.clickRequestInvite}>
                      Request invite
                    </span>
                  ) : (
                    <span onClick={this.clickSignIn}>Sign in / Sign up</span>
                  )}{' '}
                  to comment on this {{ contentType }}.
                </Trans>
              </SignInUpMessge>
            </Center>
          </Wrapper>
        ) : (
          <React.Fragment>
            <HiddenComments commentsConnection={this.commentsConnection} />
            <Comment
              app={this.appManager.commentFormApp}
              first={comments.length === 0}
              contentType={contentType}
              thread={thread}
              hideAction={hideAction}
            />
          </React.Fragment>
        )}
      </Wrapper>
    );
  }
}

const SignInUpMessge = styled.p`
  padding: 40px 0px 20px 0px;
  > a,
  span {
    color: ${props => props.theme.color.primary};
    font-weight: 600;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  ${media.s`
    padding: 40px 0px 60px 0px;
    text-align: center;
    line-height: 1.4;
  `};
`;

const Wrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 0px;
  margin-bottom: 60px;
`;

Comments.propTypes = {
  contentType: PropTypes.string,
  content: PropTypes.object,
  thread: PropTypes.bool,
  hideAction: PropTypes.bool,
  dataTestId: PropTypes.string,
};
